// src/listeners/NewGroupMessageListener.ts
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {useMessageStore} from "@src/stores/messages";
import GroupMessageService from "@src/services/groupMessage";
import NotificationsService from "@src/services/notifications";
import GroupMessage from "@src/types/GroupMessage";
import {db} from "@src/services/db";
import "@src/services/echo";
import GroupMember from "@src/types/GroupMember";
import Group from "@src/types/Group";

type GroupMessageEventPayload = {
    message: GroupMessage;
    tempId?: string | number | null;
};

export function NewGroupMessageListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const messageStore = useMessageStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".GroupMessageEvent", async (event: GroupMessageEventPayload) => {
            try {
                const msg = event?.message;
                const tempId = event?.tempId ?? null;

                if (!msg?.id || !msg?.group_id) return;

                const groupId = Number(msg.group_id);

                await GroupMessageService.updateGroupLastMessage(groupId, msg);

                const openedGroupId =
                    sessionStore.type === "group" && sessionStore.selectedSession?.id
                        ? Number(sessionStore.selectedSession.id)
                        : null;

                if (openedGroupId !== groupId) {
                    // incrementa unread_count localmente
                    const group = await db.groups.get(groupId).catch(() => null);
                    if (group) {
                        const members: GroupMember[] = group.members
                        if (msg.costumer && !members.some((m: GroupMember) => m.token === msg.costumer?.token)) {
                            await GroupMessageService.addMember(groupId, msg.costumer?.id ?? 0);
                        }
                        await db.groups.update(groupId, {
                            unread_count: (group.unread_count ?? 0) + 1,
                        } as any).catch(() => {
                        });
                    }

                    const groupName = msg?.group?.subject || "Grupo";
                    NotificationsService.notify(`${groupName}: nova mensagem.`, true);
                    return;
                }

                // aqui já sabemos que é um grupo (openedGroupId === groupId, checado via sessionStore.type)
                const selectedGroup = sessionStore.selectedSession as unknown as Group | undefined;
                const members: GroupMember[] | undefined = selectedGroup?.members
                if (members && msg.costumer && !members.some((m: GroupMember) => m.token === msg.costumer?.token)) {
                    const response = await GroupMessageService.addMember(groupId, msg.costumer?.id ?? 0);
                    if (response.length > 0) {
                        const newMember = response.find((m: GroupMember) => m.token === msg.costumer?.token)
                        selectedGroup?.members.push(newMember)
                    }
                }

                // grupo aberto: marca como lido
                GroupMessageService.markAsRead(groupId);

                const realIndex = messageStore.groupMessages.findIndex(
                    (m: GroupMessage) => Number(m.id) === Number(msg.id)
                );

                if (realIndex !== -1) {
                    return;
                }

                const tempIndex =
                    tempId != null
                        ? messageStore.groupMessages.findIndex(
                            (m: GroupMessage) => String(m.id) === String(tempId)
                        )
                        : -1;

                if (tempIndex !== -1) {
                    messageStore.groupMessages.splice(tempIndex, 1, {
                        ...msg,
                        selected: false,
                    });
                } else {
                    messageStore.groupMessages.push({
                        ...msg,
                        selected: false,
                    });
                }

                messageStore.groupLastId = Math.max(
                    Number(messageStore.groupLastId ?? 0),
                    Number(msg.id ?? 0)
                );

                await sessionStore.scrollDownGroup(true);
            } catch (e) {
                console.error("❌ erro no listener NewGroupMessageEvent", e);
            }
        });
}